// utils && hooks
import { AccessStatusIdEnum } from 'utils/enums';

export const checkPosIsDisabled = (pointOfSale: any) => {
    return [AccessStatusIdEnum.DisabledNonPayment, AccessStatusIdEnum.DisabledOther].includes(
        pointOfSale?.access_status_id,
    );
};
